import {ResourceIconPipe} from "./icon/resource.icon.pipe";
import {ResourceTemplatePipe} from "./template/resource.template.pipe";
import {ResourceMediaPipe} from "./media/resource.media.pipe";
import {i18nModule} from "@config/i18n.module";
import {NgModule} from "@angular/core";
import {HttpModule} from "@angular/http";
import {CommonModule, DatePipe} from "@angular/common";
import {ResourcesModule} from "@resources/resources.module";
import { AsiTabGroupModule } from '@asi-ngtools/lib'
import {ResourceMultimediaPipe} from "./image/resource.multimedia.pipe";
import {HighlightPipe} from "./highlight/resource.highlight.pipe";
// Form
import {FormsModule, ReactiveFormsModule} from "@angular/forms";

import {DigiCerbaCommonModule} from "@digicerba/common";
import {SafeHtmlPipe} from '@utils/safe-html.pipe';
import {DonneesManquantesComponent} from "@utils/dialog/dialog-donnees-manquantes/donnees-manquantes-component-dialog.component";
import {BodyDonneesManquantes} from "@utils/dialog/dialog-donnees-manquantes/body-donnees-manquantes/body-donnees-manquantes";
import {BodyDocumentsManquants} from "@utils/dialog/dialog-donnees-manquantes/body-documents-manquants/body-documents-manquants";

/** liste des components / directive à exporter */
var sharedDeclaration: Array<any> = [
  ResourceMultimediaPipe, ResourceTemplatePipe, ResourceMediaPipe, ResourceIconPipe, HighlightPipe, SafeHtmlPipe
];

/** liste des modules à exporter */
var sharedModules: Array<any> = [
  FormsModule, ReactiveFormsModule, CommonModule, ResourcesModule, i18nModule, AsiTabGroupModule
];

/** Liste des composants interne au module */
var declarations: Array<any> = [
  DonneesManquantesComponent, BodyDonneesManquantes, BodyDocumentsManquants
];

/** Liste des services */
var services: Array<any> = [DatePipe];

/** Liste des composants necessitant la création d'une factory */
var entryComponents: Array<any> = [
  DonneesManquantesComponent, BodyDonneesManquantes, BodyDocumentsManquants
];

@NgModule({
  imports: [DigiCerbaCommonModule.forRoot(), HttpModule, ...sharedModules],
    declarations: [...sharedDeclaration, ...declarations, ...entryComponents, BodyDocumentsManquants],
  exports: [DigiCerbaCommonModule, ...sharedDeclaration, ...sharedModules, BodyDocumentsManquants],
  providers: services,
  entryComponents: entryComponents
})
export class UtilsModule { }



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-formulaire-demat/digicerba-formulaire-demat-web/src/angular/cerba/src/app/common/utils/utils.module.ts